import { PlannerApi } from './planner.api';
import type { ApiResponse, Planner, User, UserPaginationParams } from '@vision/ui/interfaces';
import type { PlannerListArgs, PlannerDetailArgs, PlannerRelatedCountArgs } from './planner.api.types';
import {
  buildGetPlannersRequest,
  buildGetPlannerByIdRequest,
  buildFetchPlannerUsersWithPaginationRequest,
  buildRelatedPlannerCountRequest,
} from './planner.routes';

export const PlannerEndpoints = PlannerApi.injectEndpoints({
  endpoints: (builder) => ({
    getPlanners: builder.query<ApiResponse<Planner[]>, PlannerListArgs>({
      query: buildGetPlannersRequest,
      providesTags: ['Planner'],
    }),
    getPlannerById: builder.query<Planner, PlannerDetailArgs>({
      query: buildGetPlannerByIdRequest,
      providesTags: (_result, _error, { plannerId }) => [{ type: 'Planner', id: plannerId }],
    }),
    fetchPlannerUsersWithPagination: builder.query<ApiResponse<User[]>, UserPaginationParams>({
      query: buildFetchPlannerUsersWithPaginationRequest,
    }),
    relatedPlannerCount: builder.query<number, PlannerRelatedCountArgs>({
      query: buildRelatedPlannerCountRequest,
    }),
  }),
});

export const {
  useGetPlannersQuery,
  useGetPlannerByIdQuery,
  useFetchPlannerUsersWithPaginationQuery,
  useLazyFetchPlannerUsersWithPaginationQuery,
  useLazyRelatedPlannerCountQuery,
} = PlannerEndpoints;
